const appHandle = () => (import.meta as any).env?.VITE_SHOPIFY_APP_HANDLE || "flogpt";

const SHOP_DOMAIN = /^[a-z0-9][a-z0-9-]*\.myshopify\.com$/;
const REMEMBERED_SHOP_KEY = "flogpt:shopify-shop";

/** Embedded-app route that signs the merchant in and sends the tab back to the dashboard. */
export const SHOPIFY_SIGN_IN_PATH = "/app/sso";

/**
 * Deep link into this app inside a merchant's Shopify admin.
 *
 * The handle is environment-specific (the dev and production apps are separate
 * listings), so every link has to resolve it rather than hard-code "flogpt".
 */
export const shopifyAdminAppUrl = (shopDomain?: string | null, path = "") => {
    const shop = String(shopDomain || "").trim();
    if (!shop) return null;
    return `https://${shop}/admin/apps/${appHandle()}${path}`;
};

const toShopDomain = (value: unknown) => {
    const shop = String(value ?? "").trim().toLowerCase();
    return SHOP_DOMAIN.test(shop) ? shop : null;
};

/**
 * The store this browser last signed in through Shopify from.
 *
 * Lives outside the persisted session so it survives logout: a merchant
 * installed from Shopify has no password, and this is the only way the login
 * page knows where to send them back. It is a hint, not a credential — Shopify
 * still authenticates the round trip — but it becomes the host of a redirect,
 * so it is validated on the way in and on the way out.
 */
export const rememberShopifyShop = (shopDomain?: string | null) => {
    const shop = toShopDomain(shopDomain);
    if (shop) localStorage.setItem(REMEMBERED_SHOP_KEY, shop);
};

export const rememberedShopifyShop = () => toShopDomain(localStorage.getItem(REMEMBERED_SHOP_KEY));
